import React, { PropsWithChildren } from "react";
import { useResponsiveBelowXl } from "src/hooks";
import { OuterBoxBelowXl } from "./OuterBoxBelowXl";
import { OuterBox } from "./OuterBox";

export const SidebarOuterBox: React.FC<PropsWithChildren> = ({ children }) => {
  const isBelowXl = useResponsiveBelowXl();

  return isBelowXl ? (
    <OuterBoxBelowXl>{children}</OuterBoxBelowXl>
  ) : (
    <OuterBox>{children}</OuterBox>
  );
};
